import styled from 'styled-components'

export interface StripeProps {
  overflowX?: string
  backgroundColor: string
}

export const LinkWrapper = styled.div`
  a {
    display: block;
    color: ${({ theme }) => theme.colors.palette.neutral300};

    span.anchor-text {
      display: inline-block;
      ${({ theme }) => ({ ...theme.size.xxs })};
    }

    &:hover {
      span.anchor-text {
        text-decoration: underline !important;
      }
    }
  }
`;

export const StripeWrapper = styled.div<StripeProps>`
  max-width: 100%;
  position: relative;
  ${({ theme }) => ({ ...theme.size.xs })};
  color: ${({ theme }) => theme.colors.palette.neutral300};
  background: ${({ backgroundColor }) => backgroundColor};
  overflow-x: ${({ overflowX }) => overflowX};

  .content {
    display: flex;
    align-items: center;
    overflow: hidden;
    line-height: 1rem;
    height: 70px;
  }

  strong {
    color: ${({ theme }) => theme.colors.white};
    ${({ theme }) => ({ ...theme.typography.primary.semiBold })};
  }



  img {
    width: 40px;
    overflow: hidden;
    margin: 0 0.5rem 0 1rem;
    min-width: 40px;
  }

  .icon {
    width: 40px;
    height: 40px;
    margin: 0 0.5rem 0 1rem;
    min-width: 40px;
  }

  .wrapper {
    display: flex;
    flex-direction: column;
    overflow: hidden;
    min-width: 200px;
    padding: 1rem 0;
  }
`

export const ButtonFloat = styled.div`
  display: none;
  @media (max-width: 767px) {
    position: ${'absolute'};
    right: -12px;
    top: 20px;
    width: 30px;
    height: 30px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 50%;
    ${({ theme }) => ({ ...theme.size.sm })};
    background-color: ${({ theme }) => theme.colors.secondaryBackgroundColor};
    z-index: 999;
    cursor: pointer;

    svg {
      fill: #fff;
      position: relative;
      left: -1px;
    }
  }
`
